export enum PermissionCode {
  ADMIN_PRIVILEGES = 'custom.admin_privileges',
  DEVELOPER_PRIVILEGES = 'custom.developer_privileges',
  MANAGE_CDFI_PROFILE = 'custom.manage_cdfi_profile',
  GET_SET_LEADS = 'custom.get_set_leads',
  ACCESS_DATA_AXLE = 'custom.access_data_axle',
  ACCESS_CRF = 'custom.access_crf',
  ACCESS_DNB = 'custom.access_dnb',
  ACCESS_DEEPROOTS = 'custom.access_deeproots',
  MANAGE_PUBLIC_LINKS = 'custom.manage_public_links',
  MANAGE_MATCHING_CRITERIA = 'custom.manage_matching_criteria',
  CUSTOM_BUSINESS_RECORD = 'custom.custom_business_record',
  UPLOAD_RECORDS = 'custom.upload_records',
  SEARCH_BY_SOURCE = 'custom.search_by_source',
  ACCESS_VLF = 'custom.access_vlf',
  MANAGE_SUBSCRIPTION = 'custom.manage_subscription',
  VIEW_OPPORTUNITY_INDICATOR = 'custom.view_opportunity_indicator',
}
